export default __webpack_public_path__ + "static/brcc-full-width-3-22fb32490237600a65715c4c542ca333.webp";